module.exports = __webpack_public_path__ + "static/img/p2.1ddc7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2.jpg
// module id = vlXn
// module chunks = 1